import React from "react";

type CellIndex = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;

const M_PATH: CellIndex[] = [6, 3, 0, 4, 2, 5, 8];

export default function CustomPageLoader() {
  return (
    <div className="fixed inset-0 z-9999 flex items-center justify-center bg-white/70 backdrop-blur-[6px]">
      <div className="p-3 bg-white border border-[rgb(var(--primary-alpha)/0.8)] rounded-xl shadow-md">
        <div className="grid grid-cols-3 grid-rows-3 gap-2">
          {Array.from({ length: 9 }).map((_, index) => {
            const step = M_PATH.indexOf(index as CellIndex);

            return (
              <span
                key={index}
                className={`rounded-full w-1.5 h-1.5 bg-(--primary) ${step === -1 ? "opacity-10" : "loader-dot opacity-40"}`}
                style={
                  step !== -1
                    ? {
                        animationDelay: `${step * 100}ms`,
                        // first point stays Primary longer
                        animationDuration: step === 0 ? "1.5s" : "1.5s",
                      }
                    : undefined
                }
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}
